import { fetchRS } from "../utils/fetchRS";

export const sendPesosToErp = (body: { [key: string]: any }) =>
  fetchRS(`${process.env.REACT_APP_API_URL}/erp/envio-pesos`, {
    method: 'POST',
    objectBody: body,
  });
